export default {
  name: 'Aenume',
  props: {
    value: '',
    index: { type: String, default: () => 'type' },
    field: { type: String, default: () => '' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    emptyContent: { type: String, default: () => '' },
  },
  methods: {
    format(value) {
      const list = this.options || this.option || this.config || this.items || this.data || [];
      const data = [];
      for (let a in list) {
        if (list[a][this.index] == this.field.toLowerCase()) {
          data.push({
            label: list[a].name || list[a].label || list[a].title,
            value: list[a].id || list[a].code || list[a].value,
            color: list[a].color,
          });
        }
      }
      for (let a in data) {
        if (data[a].value == value) {
          return data[a].render ? data[a].render() : (<span style={{ color: data[a].color, ...data[a].style }}>{data[a].label}</span>);
        }
      }
      return this.emptyContent;
    }
  },
  render() {
    return this.format(this.value);
  }
}